import React, { FC } from 'react';
import LoginDefaultSpinner from '../LoginDefaultSpinner/LoginDefaultSpinner';
import SkeletonLoaderDynamic from '../SkeletonLoader/SkeletonLoader';

/**
 * Define the available loading style
 */
export enum LoadingStyleEnum {
  SPINNER = 'SPINNER',
  SKELETON = 'SKELETON',
}

/**
 * Define the props for the LoadingOrError component
 */
interface LoadingOrErrorProps {
  loading: boolean;
  loadingStyle?: LoadingStyleEnum;
  children?: any;
  error?: any;
  loadingMessage?: string;
}

/**
 * Component for loading animation or error message
 */
const LoadingOrError: FC<LoadingOrErrorProps> = props => {
  const { loading, error, loadingStyle = LoadingStyleEnum.SPINNER, loadingMessage } = props;

  // If not loading, return the children
  if (!loading) return props?.children;

  if (error) {
    console.error(error);
  }

  switch (loadingStyle) {
    case LoadingStyleEnum.SPINNER:
      return <LoginDefaultSpinner loadingMessage={loadingMessage} />;
    case LoadingStyleEnum.SKELETON:
      return (
        <>
          <SkeletonLoaderDynamic
            itemHeight={220}
            itemWidth={420}
            rowNumber={3}
            loading={true}
            style={{
              marginTop: '30px',
              marginBottom: '10px',
              padding: '0 20px',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          />

          <SkeletonLoaderDynamic
            itemHeight={35}
            itemWidth={420}
            rowNumber={3}
            loading={true}
            style={{
              marginTop: '30px',
              marginBottom: '10px',
              padding: '0 20px',
              display: 'flex',
              justifyContent: 'space-between',
            }}
          />

          <SkeletonLoaderDynamic
            itemHeight={20}
            fullWidth={true}
            itemWidth={0}
            rowNumber={1}
            loading={true}
            style={{ marginTop: '35px', padding: '0 20px' }}
          />

          <SkeletonLoaderDynamic
            itemHeight={45}
            fullWidth={true}
            itemWidth={0}
            rowNumber={7}
            loading={true}
            style={{
              marginTop: '25px',
              marginBottom: '25px',
              padding: '0 20px',
              display: 'flex',
              gap: '18px',
            }}
          />
        </>
      );
    default:
      return <LoginDefaultSpinner loadingMessage={loadingMessage} />;
  }
};

export default LoadingOrError;
